export const adaptCuidadosDomiciliariosRI = ({ cuidadosDomiciliariosRIById }) => {
    const { cuidadosDomiciliariosRI, videodeglucionAdjunto } = cuidadosDomiciliariosRIById;
    return {
        idDatosGeneralesRI: cuidadosDomiciliariosRI?.idDatosGeneralesRI,
        cuidadosDomiciliarios1: {
            idCuidadosDomiciliariosRI: cuidadosDomiciliariosRI?.idCuidadosDomiciliariosRI,
            sNC: cuidadosDomiciliariosRI?.sNC,
            cV: cuidadosDomiciliariosRI?.cV,
            respiratorio: cuidadosDomiciliariosRI?.respiratorio,
            digestivo: cuidadosDomiciliariosRI?.digestivo,
            videodeglucion: cuidadosDomiciliariosRI?.videodeglucion,
            videodeglucionAdjunto: {
                contentType: videodeglucionAdjunto?.contentType,
                archivo: videodeglucionAdjunto?.archivo,
                extension: videodeglucionAdjunto?.extension,
                titulo: videodeglucionAdjunto?.titulo,
            },
            otros: cuidadosDomiciliariosRI?.otros,
            traqueostomia: cuidadosDomiciliariosRI?.traqueostomia,
            sondaVesical: cuidadosDomiciliariosRI?.sondaVesical,
            ostomia: cuidadosDomiciliariosRI?.ostomia,
            cateter: cuidadosDomiciliariosRI?.cateter,
            sondaNasogastrica: cuidadosDomiciliariosRI?.sondaNasogastrica,
            idComboRIValorCalendarioVacunas: cuidadosDomiciliariosRI?.idComboRIValorCalendarioVacunas,
            idComboRIValorAduKarnofsky: cuidadosDomiciliariosRI?.idComboRIValorAduKarnofsky,
            idComboRIValorPedLansky: cuidadosDomiciliariosRI?.idComboRIValorPedLANSKY,
            requiereSoporteNutricional: cuidadosDomiciliariosRI?.requiereSoporteNutricional,
        },
        cuidadosDomiciliarios2: {
            idCuidadosDomiciliariosRI: cuidadosDomiciliariosRI?.idCuidadosDomiciliariosRI,
            idComboRIValorTabaquismo: cuidadosDomiciliariosRI?.idComboRIValorTabaquismo,
            antecedentesAlcoholismo: cuidadosDomiciliariosRI?.antecedentesAlcoholismo,
            antecedenteConsumoSustancia: cuidadosDomiciliariosRI?.antecedentesConsumoSustancias,
            tipoSustancia: cuidadosDomiciliariosRI?.tipoSustancia,
            infusionDrogas: cuidadosDomiciliariosRI?.infusionDrogas,
            drogasAInfundir: cuidadosDomiciliariosRI?.drogasAInfundir,
            dosis: cuidadosDomiciliariosRI?.dosis,
            frecuencia: cuidadosDomiciliariosRI?.frecuencia,
            cumpleCriterioIngreso: cuidadosDomiciliariosRI?.cumpleCriterioIngreso,
            infusionesPrevias: cuidadosDomiciliariosRI?.infusionesPrevias,
            cuantas: cuidadosDomiciliariosRI?.cuantas,
            donde: cuidadosDomiciliariosRI?.donde,
            reaccionesAdversas: cuidadosDomiciliariosRI?.reaccionesAdversas
        }
    }
}
